<template>
  <div>
    <Main ref="main" :loading="loading" :tableData="tableData" />
  </div>
</template>

<script>
import Main from './main'
import BaseTable from '@/mixins/base-table'
import { multiply, divideDown } from '@/libs/util.number.js'
export default {
  mixins: [BaseTable],
  components: { Main },
  props: { amzReplenishmentDetailCode: { type: String, default: '' } },
  data() {
    return { loading: false, tableData: [] }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzReplenishmentDetailCode) return []
      const params = {
        amzReplenishmentDetailCode: this.amzReplenishmentDetailCode,
      }
      const res = await this.$api
        .ecomAmzReplenishmentDetailReplyListApi(params)
        .catch(() => null)
      const data = res?.body?.data || []
      this.tableData = data.map((item) => {
        const { qty, inCtnQty } = item
        const ctnQty = divideDown(qty, inCtnQty, 0)
        const tailQty = qty - multiply(inCtnQty, ctnQty)
        const tailCtnQty = tailQty ? 1 : 0
        const totalCtnQty = ctnQty + tailCtnQty
        return { ...item, ctnQty, tailQty, tailCtnQty, totalCtnQty }
      })
    },
  },
}
</script>
